var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContragent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1695)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 21C16 18.8783 15.1571 16.8434 13.6569 15.3431C12.1566 13.8429 10.1217 13 8 13C5.87827 13 3.84344 13.8429 2.34315 15.3431C0.842855 16.8434 3.20373e-07 18.8783 0 21L8 21H16Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9443 20H20C20 18.9391 19.5786 17.9217 18.8284 17.1716C18.0783 16.4214 17.0609 16 16 16C15.8333 16 15.6676 16.0104 15.5039 16.0309C16.2898 17.2177 16.7854 18.578 16.9443 20ZM15.9373 20C15.7688 18.6628 15.2652 17.3907 14.4753 16.302C13.9922 16.5012 13.5482 16.7949 13.1716 17.1716C12.4214 17.9217 12 18.9391 12 20L15.9373 20Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 12,
    r: 3,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 7C13 9.76142 10.7614 12 8 12C5.23858 12 3 9.76142 3 7C3 4.23858 5.23858 2 8 2C10.7614 2 13 4.23858 13 7Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1695"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContragent);
export default __webpack_public_path__ + "static/media/contragent.a6eb72e9a8782b8df864c4d4bcc741a1.svg";
export { ForwardRef as ReactComponent };